import { CcAnimatedLink } from "@/components/ui/CcAnimatedLink";
import { CcButton } from "@/components/ui/CcButton";
import type { BookCallPopupVariant } from "@/lib/book-call-popup-copy";

export type CcSeoCtaRowCopy = {
  primaryCta: string;
  secondaryCta?: string;
  secondaryHref?: string;
};

/** Book-a-call only (no secondary link). */
export type CcSeoCtaRowPrimaryCopy = Pick<CcSeoCtaRowCopy, "primaryCta">;

type CcSeoCtaRowProps = {
  copy: CcSeoCtaRowCopy;
  /** Book-a-call popup copy; defaults to the site-wide variant. */
  bookCallVariant?: BookCallPopupVariant;
  className?: string;
  /** Hero CTAs are start-aligned; mid-page bands often center the pair. */
  align?: "start" | "center";
};

/** Primary book-a-call button plus optional text link (SEO / service page pattern). */
export function CcSeoCtaRow({
  copy,
  bookCallVariant = "default",
  className,
  align = "start",
}: CcSeoCtaRowProps) {
  const alignClass = align === "center" ? " cc-seo-cta-row--center" : "";
  const showSecondary = copy.secondaryCta && copy.secondaryHref;

  return (
    <div
      className={`cc-seo-hero__actions cc-seo-cta-row${alignClass}${className ? ` ${className}` : ""}`}
    >
      <CcButton
        bookCallPopup
        bookCallVariant={bookCallVariant}
        label={copy.primaryCta}
        expand
        expandCompact
        className="cc-seo-hero__cta"
      />
      {showSecondary ? (
        <CcAnimatedLink
          href={copy.secondaryHref!}
          arrow
          className="cc-seo-hero__secondary-cta"
        >
          {copy.secondaryCta!}
        </CcAnimatedLink>
      ) : null}
    </div>
  );
}
